import useModalDispatch from "../../hooks/useModalDispatch";
import PaymentModal from "../../modals/PaymentModal";
import { Compensation } from "../../types/Compensation";
import Button from "../theme/Button";

const PaymentButton = ({
  compensation,
  refreshList,
}: {
  compensation: Compensation;
  refreshList: () => void;
}) => {
  const { id, userName } = compensation;
  const modalProps = {
    compensationId: id,
    userName,
    onFailure: refreshList,
    onSuccess: refreshList,
  };
  const dispatchPaymentModal = useModalDispatch(PaymentModal);

  return (
    <Button
      color="secondary"
      sx={{ flexShrink: 0 }}
      variant="contained"
      onClick={() => {
        dispatchPaymentModal(modalProps);
      }}
    >
      Vergoeden
    </Button>
  );
};

export default PaymentButton;
